const hostApi = process.env.REACT_APP_ENV.includes('development')
    ? 'http://localhost'
    : (process.env.REACT_APP_ENV.includes('uat') ? 'https://uat.testandtag.co.nz' : 'https://app.testandtag.co.nz');
const portApi = process.env.REACT_APP_ENV.includes('development') ? 80 : '';
const adminApi = `${hostApi}${portApi ? `:${portApi}` : ``}/client/admin`;
const clientApi = `${hostApi}${portApi ? `:${portApi}` : ``}/client`;
const googleStorageUrl = 'https://storage.googleapis.com/' + (process.env.REACT_APP_ENV.includes('uat') ? 'tt-images-uat' : 'tt-images') + '/';
const googleFileStorageUrl = 'https://storage.googleapis.com/' + (process.env.REACT_APP_ENV.includes('uat') ? 'tt-files-uat' : 'tt-files') + '/';
const teamChatUrl = 'https://teams.microsoft.com/l/chat/0/0?users=<USERS>&topicName=<TOPIC_NAME>';
const teamChatWithMessageUrl = 'https://teams.microsoft.com/l/chat/0/0?users=<USERS>&topicName=<TOPIC_NAME>&message=<CONTENT>';

export default {
  hostApi,
  portApi,
  adminApi,
  clientApi,
  googleStorageUrl,
  googleFileStorageUrl,
  teamChatUrl,
  teamChatWithMessageUrl
};
